import { Workspace } from '@/models/Workspace';
import { ApiBaseServiceProvider } from './ApiBaseServiceProvider';
import axios from 'axios';

export class BrowseServiceProvider extends ApiBaseServiceProvider {
  scope = 'browse';

  getWorkspace(shortId: string) {
    return axios.get(this.getBaseUrl() + shortId, this.getRequestConfig());
  }

  getPublicWorkspace(workspaceShortId: string) {
    return axios.get<{ workspace: Workspace }>(
      `${this.getBaseUrl()}workspace/public/${workspaceShortId}`,
      this.getRequestConfig()
    );
  }

  getSharedArticle(token: string) {
    return axios.get(`${this.getBaseUrl()}shared/${token}`, this.getRequestConfig());
  }

  getPrivatelySharedArticle(token: string) {
    return axios.get(`${this.getBaseUrl()}shared/${token}/private`, this.getRequestConfig());
  }

  // SNAP-2311: `token` scopes the request to the shared article's company on the backend
  // (an anonymous caller has no session to scope by otherwise). Optional so an old build that
  // hasn't picked up the paired frontend change still compiles against the new endpoint.
  getSharedImageUrl = (path: string, token?: string | null) => {
    return axios.post(this.getBaseUrl() + 'shared/image/url', { path, token }, this.getRequestConfig());
  };

  getSharedFileAttachmentUrl(path: string, token?: string | null) {
    return axios.post<{ signedUrl: string }>(
      this.getBaseUrl() + 'shared/file-attachment/url',
      { path, token },
      this.getRequestConfig()
    );
  }

  getSharedArticleCompanyLogo(articleId: string) {
    return axios.get<{ logo: string | null }>(
      `${this.getBaseUrl()}shared/company/logo/${articleId}`,
      this.getRequestConfig()
    );
  }
}
